module.exports = __webpack_public_path__ + "img/dzzlp.5cc1f467.png";